import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { supabase } from "./lib/safeSupabase";
import { initErrorLogging } from "./lib/errorLogger";
import { installStaleDeployListener } from "./lib/staleDeploy";
import { installDeployWatcher } from "./lib/deployWatcher";
import { getClockSkewMs } from "./lib/authResilience";
import "./index.css";

// The watcher must be installed before the stale-chunk listener below,
// because the listener hands dead chunks to it.
//
// Notice a newer production build while this tab is open; the app rolls over
// to it at the advisor's next navigation (see deployWatcher.ts for the policy).
// The skew estimate keeps the "how long since the merge" clock honest on a
// machine whose own clock is wrong (Andrew's laptop, the sign-out saga).
installDeployWatcher({ clockSkewMs: getClockSkewMs });

// Any lazy chunk 404ing after a new deploy (stale tab) fires vite:preloadError.
// That is proof the build moved, so it flags the watcher and the header pill
// appears — no toast, no keyboard instructions, no permanent red box.
installStaleDeployListener();

// Wire the session-independent error logger before the app mounts. The URL + anon
// key are public (already in the bundle); passing them here keeps errorLogger
// portable and avoids editing the auto-generated supabase client.
initErrorLogging({
  supabase,
  clockSkewMs: getClockSkewMs,
  supabaseUrl: "https://qhorihcqlsecytkugacn.supabase.co",
  anonKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFob3JpaGNxbHNlY3l0a3VnYWNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI0NzQ5MTcsImV4cCI6MjA4ODA1MDkxN30.H2ISBY82dirIGF7gDwrD5hqIreoRIZTtZOpi4kLFCoU",
});

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
